import { createEntityAdapter, createSelector } from "@reduxjs/toolkit";
import { apiSlice } from "../../app/api/apiSlice";

//createEntityAdapter A function that generates a set of prebuilt reducers and selectors for performing CRUD operations on a normalized state structure containing instances of a particular type of data object.
const usersAdapter = createEntityAdapter({})
// Entities cannot be iterated over but the ids can, so we use ids to get data from the entities, thats why we are using createEntityAdapter

const initialState = usersAdapter.getInitialState()
export const usersApiSlice = apiSlice.injectEndpoints({
    endpoints:builder => ({
        getUsers: builder.query({
            query: ()=> ({
                url:'/users',
                validateStatus: (response, result) => {
                    return response.status === 200 && !result.isError
                },
            }),
        // keepUnusedDataFor: 5, //This was romoved as after making an edit it was shown for 5 sec and then it went to loading... and the default is 60 seconds so for this reason we have created an active subscription[ prefetch.js in the Auth folder]
        transformResponse: responseData => {
            const loadedUsers = responseData.map(user =>{
                // This is for setting the id from the mongoDB
                user.id = user._id
                return user
            })
            return usersAdapter.setAll(initialState, loadedUsers)
        },
        provideTags: (result,error, arg)=>{
            if(result?.ids){
                return [
                    {type: 'User', id: 'LIST'},
                    ...result.ids.map(id=>({type: 'User', id}))
                ]
            }else return [{type: 'User', id: 'LIST'}]
        }
    }),
    addNewUser: builder.mutation({
        query: initialUserData => ({
            url:'/users',
            method: 'POST',
            body: {
                ...initialUserData,
            }
        }),
        invalidatesTags:[
            {type: 'User', id: "LIST"}
        ]
    }),
    updateUser: builder.mutation({
        query: initialUserData =>({
            url: '/users',
            method: 'PATCH',
            body:{
                ...initialUserData
            }
        }),
        invalidatesTags: (result, error, arg)=>[
            {type: 'User', id: arg.id}
        ]
    }),
    deleteUser : builder.mutation({
        query: ({id}) =>({
            url: '/users',
            method: 'DELETE',
            body:{id}
        }),
        invalidatesTags: (result, error, arg)=>[
            {type: 'User', id: arg.id}
        ]
    }),
})
})

export const {useGetUsersQuery, useAddNewUserMutation, useUpdateUserMutation, useDeleteUserMutation} = usersApiSlice
//returns the Query result object
export const selectUserResult = usersApiSlice.endpoints.getUsers.select()

// creates memoized selector
// Memoized meaning: storing the result so you can use it next time instead of calculating the same thing again and again.
const selectUsersData = createSelector(selectUserResult, usersResult => usersResult.data //normalized state object with ids and entities
)
// getSelectors creates these selectors and we rename them aliases using destructring
export const {
    selectAll: selectAllUsers,
    selectById: selectUserById,
    selectIds: selectUserIds
    // pass in a selector that returns the users slice of state
} = usersAdapter.getSelectors(state => selectUsersData(state) ?? initialState)
